<div
  [class.highlight]="highlight"
  class="relative mt-12 mb-4 flex w-64 flex-col rounded-lg transition-colors duration-50 bg-primary-50 "
>
  <div class="flex flex-col items-center justify-between px-5 pt-5 lg:justify-center">
    <img src="assets/img/benefits.png" alt="Korzyści" />
  </div>
  <div class="flex-grow p-5 text-lg md:text-xs">
    <div class="mb-3 font-bold leading-4 text-primary-700 lg:mb-4">
      Wszystkie Twoje rachunki<br />
      w jednym miejscu!
    </div>
    <div class="mb-4 font-normal text-primary-900/60">
      Podłącz swoje rachunki do wybranego banku lub aplikacji i skorzystaj z udogodnień.
    </div>
    <ul class="mb-3">
      <li *ngFor="let benefit of BENEFITS" class="mb-1.5 flex items-center text-primary-700">
        <mat-icon class="mr-1 icon-16">check_circle_outline</mat-icon>
        <span class="font-normal text-xs">{{ benefit }}</span>
      </li>
    </ul>
    <span class="text-primary-900/60">i wiele więcej!</span>
  </div>

  <span [class.active]="highlight" class="transition-colors duration-50 triangle"></span>
</div>
